import { BreakpointObserver } from "@angular/cdk/layout";
import { DestroyRef, inject, Injectable, signal, WritableSignal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { SidenavService } from "@app/core/services/sidenav.service";
import { BREAKPOINTS } from "@app/shared/constants/breakpoints.constants";

@Injectable({
  providedIn: "root"
})
export class BreakpointService {
  private breakpointObserver = inject(BreakpointObserver);
  private sidenavService = inject(SidenavService);
  private _printEvent = signal<boolean>(false);
  private _isMobile = signal<boolean>(false);
  private _isMedium = signal<boolean>(false);
  private _isLarge = signal<boolean>(false);
  private _destroyRef: DestroyRef = inject(DestroyRef);

  /**
   * Monitor breakpoints for application
   */
  startBreakPointInterceptor() {
    this.breakpointObserver
      .observe([BREAKPOINTS.isMobile, BREAKPOINTS.isMedium, BREAKPOINTS.isLarge])
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((state: any) => {
        this.isMobile = state.breakpoints[BREAKPOINTS.isMobile];
        this.isMedium = state.breakpoints[BREAKPOINTS.isMedium];
        this.isLarge = state.breakpoints[BREAKPOINTS.isLarge];

        if (this._printEvent()) {
          this._printEvent.set(false);
          return;
        }

        this.sidenavService.monitorSideNavOpenStatus(!this.isMobile(), this.isMobile());
      });
  }

  // Flag to prevent Print Dialog from firing the breakpoint observer and causing the sidenav to misbehave.
  setPrintEvent(val: boolean) {
    this._printEvent.set(val);
  }

  /**
   * Returns true if screen size matches set breakpoint for mobile devices
   */
  get isMobile(): WritableSignal<boolean> {
    return this._isMobile;
  }

  /**
   * Sets the isMobile value based on breakpoint subscription
   * in app.component.ts
   */
  set isMobile(isMobile: boolean) {
    this._isMobile.set(isMobile);
  }

  /**
   * Returns true if screen size matches set breakpoint for medium size screens(tablet, etc)
   */
  get isMedium(): WritableSignal<boolean> {
    return this._isMedium;
  }

  /**
   * Sets the isMedium value based on breakpoint subscription
   * in app.component.ts
   */
  set isMedium(isMedium: boolean) {
    this._isMedium.set(isMedium);
  }

  /**
   * Returns true if screen size matches set breakpoint for desktops
   */
  get isLarge(): WritableSignal<boolean> {
    return this._isLarge;
  }

  /**
   * Sets the isLarge value based on breakpoint subscription
   * in app.component.ts
   */
  set isLarge(isLarge: boolean) {
    this._isLarge.set(isLarge);
  }
}
